export const chooseReasonInfo = [
    {
        title: 'Trust',
        detail: 'We view trust as the core of our business relationships, continuously strengthening it through transparent communication and consistent actions with clients, partners, and employees. We believe that enduring trust is the foundation for successful collaboration and long-term relationships.',
        path: 'heart',
    },                     
    {
        title: 'Responsibility',
        detail: 'In providing decision support and strategic consulting, we take full responsibility for the social and business impacts. Through responsible consulting practices, we ensure that clients operate within ethical and legal frameworks while helping them achieve their sustainability goals.',
        path: 'resp',
    },
    {
        title: 'Professionalism',
        detail: 'We are committed to excellence in all our professional fields. By promoting continuous education and implementing industry best practices, we ensure our team possesses unparalleled expertise and skills in strategy, risk management, and market analysis.',
        path: 'prof',
    },
    {
        title: 'Reliability',
        detail: 'WIT Consulting is committed to being the most trusted advisor for our clients, fulfilling our promises accurately and on time. We ensure that each project is completed to high-quality standards, earning our clients\' long-term trust and confidence.',
        path: 'reliable',
    },
    {
        title: 'Teamwork',
        detail: 'We value teamwork, encourage interdisciplinary collaboration, and foster innovative thinking. By integrating expertise and perspectives from various fields, we provide clients with comprehensive and insightful solutions to effectively address complex issues.',
        path: 'teamwork',
    },
    {
        title: 'Confidentiality',
        detail: 'We adhere to the strictest confidentiality principles when handling all client information and data. By implementing advanced security measures and following industry confidentiality standards, we ensure the protection of client information from any threats, safeguarding their interests and trust.',
        path: 'sc',
    }
]
